import state from './modulePropertyListingStatusState.js'
import mutations from './modulePropertyListingStatusMutations.js'
import actions from './modulePropertyListingStatusActions.js'
import getters from './modulePropertyListingStatusGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
